import { PositionAssetTypeEnum } from '../../../types';

/**
 * Resolves the Underlying identity for a position row.
 * Uses ExposureGroupAsset when the server provides one (including Spot/Share pair instruments).
 * Falls back to Asset for Spot and Share when ExposureGroupAsset is missing (balance-derived rows).
 */
export function resolvePositionUnderlying({
  asset,
  assetType,
  exposureGroupAsset,
}: {
  asset: string | null | undefined;
  assetType: PositionAssetTypeEnum | undefined;
  exposureGroupAsset?: string | null;
}): string | undefined {
  if (asset == null) {
    return undefined;
  }

  if (exposureGroupAsset) {
    return exposureGroupAsset;
  }

  if (assetType === PositionAssetTypeEnum.Spot || assetType === PositionAssetTypeEnum.Share) {
    return asset;
  }

  return undefined;
}
